import {
    isPensionInputStateValid,
} from 'utils/PenlyPlay/penlyPlayPensionHelpers';
import initialState from './initial';
import * as types from '../constants/pensiongoals';

const pensionGoalsReducers = (state = initialState.pensiongoals, action) => {
    const { type, payload } = action;

    switch (type) {
        case types.PENSIONGOALS_RESET: {
            const resetState = { ...initialState.pensiongoals, ...payload };
            const hasRequiredPensionInput = isPensionInputStateValid(resetState);
            return { ...resetState, hasRequiredPensionInput };
        }
        case types.PENSIONGOALS_STATE_UPDATED: {
            const updatedState = { ...state, ...payload };
            const hasRequiredPensionInput = isPensionInputStateValid(updatedState);
            return { ...initialState.pensiongoals, ...updatedState, hasRequiredPensionInput };
        }
        case types.PENSIONGOALS_SAVE_REQUEST: {
            return { ...initialState.pensiongoals, ...state, saved: false };
        }
        case types.PENSIONGOALS_SAVE_SUCCESS: {
            return { ...initialState.pensiongoals, ...state, saved: true };
        }
        case types.PENSIONGOALS_SAVE_FAILED: {
            return { ...initialState.pensiongoals, ...state, saved: false, error: { message: 'Der skete desværre en fejl, prøv igen senere' } };
        }
        default:
            return state;
    }
};

export default pensionGoalsReducers;
